














import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: { BaseButton }
})
export default class TesTab extends Vue {
  @Prop({ required: true }) value !: any
  @Prop({ required: true }) val !: any
  @Prop({ default: undefined }) label !: any
  @Prop({ default: 'bg-tes-red' }) activeColor!: string
  @Prop({ default: 'tes-navy-blue-dark' }) textColor!: string
  @Prop({ default: false }) loading!: boolean

  onClick() {
    this.$emit('input', this.val)
  }
}
